import MatchesTodayTime from './MatchesTodayTime';

export default function MatchesToday ({ matches, isLoading }) {
    if (isLoading) {
        return '';
    }
    const selectedMatch = matches[0].matches[0];
    return (
        <div class="row">
            <div class="col-6">
                <div class="card-header d-flex justify-content-between">
                    <h3 class="d-inline text-white m-0">DAGENS MATCHER</h3>
                </div>
                <div class="current-matches todays-matches d-inline-block">
                    <div>
                    { matches.map((matchTime) => {
                        return <MatchesTodayTime matchTime={matchTime}></MatchesTodayTime>        
                    })}
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="selected-match">
                    <svg xmlns="http://www.w3.org/2000/svg" width="601" height="438" viewBox="0 0 601 438" fill="none">
                        <path d="M147.447 0.108154L9.03208 13.3668C4.41508 13.8091 0.890259 17.6877 0.890259 22.3258L0.890266 414.639C0.890267 419.497 4.74451 423.477 9.59922 423.635L452.164 437.955L592 425.475C596.642 425.061 600.2 421.171 600.2 416.511L600.2 24.1068C600.2 19.2546 596.354 15.2758 591.504 15.112L147.447 0.108154Z" fill="url(#pattern0)"/>
                        <path d="M147.447 0.108154L9.03208 13.3668C4.41508 13.8091 0.890259 17.6877 0.890259 22.3258L0.890266 414.639C0.890267 419.497 4.74451 423.477 9.59922 423.635L452.164 437.955L592 425.475C596.642 425.061 600.2 421.171 600.2 416.511L600.2 24.1068C600.2 19.2546 596.354 15.2758 591.504 15.112L147.447 0.108154Z" fill="url(#paint0_linear_236_2871)" style={{mixBlendMode: 'multiply'}}/>
                        <path d="M9.07976 13.8645L147.462 0.608962L591.487 15.6117C596.067 15.7664 599.7 19.5241 599.7 24.1068L599.7 416.511C599.7 420.912 596.34 424.586 591.956 424.977L452.149 437.454L9.61539 423.135C5.03038 422.986 1.39027 419.227 1.39027 414.639L1.39026 22.3258C1.39026 17.9453 4.71925 14.2822 9.07976 13.8645Z" stroke="white" stroke-opacity="0.15"/>
                        <defs>
                            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use href="#image0_236_2871" transform="matrix(0.000927138 0 0 0.00126904 -0.148997 0)"/>
                            </pattern>
                            <linearGradient id="paint0_linear_236_2871" x1="311.996" y1="103.93" x2="270.045" y2="408.143" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#0E204D" stop-opacity="0.25"/>
                            <stop offset="1" stop-color="#0E204D"/>
                            </linearGradient>
                            <image id="image0_236_2871" width="1400" height="788" href="/wp-content/themes/sef-leagues/images/arena.png"/>
                        </defs>
                    </svg>
                    <div class="match-details">
                        <div class="round">
                            <span>{matches[0].time}</span>
                        </div>
                        <div>
                            <div class="teams d-inline-block">
                                <span>{selectedMatch.homeTeamName + ' - ' + selectedMatch.visitingTeamName}</span>
                            </div>
                        </div>
                        <div class="match-footer">
                            <div class="follow-match">
                                <a>Inför</a>
                            </div>
                            <div class="buy-ticket">
                                <a>Köp biljetT</a>
                            </div>
                            <div class="match-info">
                                <div class="arena-name">
                                    <img src="/wp-content/themes/sef-leagues/images/arena-logo.png" />
                                    <span>Stora valla</span>
                                </div>
                                <div class="league-round">
                                    <img src="/wp-content/themes/sef-leagues/images/league-logo-white.png" />
                                    <span>OMGÅNG 18</span>
                                </div>
                                <div class="arena-capacity">
                                    <img src="/wp-content/themes/sef-leagues/images/arena-capacity.png" />
                                    <span>11 234</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}